import React from "react";
import { offerConfig } from "../../data/megapack";
import { E } from "../Emoji";
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-night" data-id="element-170" data-mp="1p343ci660wc7">
      <div className="mx-auto max-w-2xl px-5 pb-14 text-center" data-id="element-171" data-mp="1kbc83uc2e2fq">
        <span className="text-5xl" data-id="element-172" data-mp="1k9j0octmne6o"><E data-id="element-173" data-mp="1fd12xwwpsg3u">🛡️</E></span>
        <h2 id="garantia" className="mt-2 text-3xl font-black text-bright" data-id="element-174" data-mp="1fbpyrvzcx6c7">
          GARANTÍA {offerConfig.guaranteeDays} DÍAS
        </h2>
        <div className="mt-5 space-y-2 rounded-2xl border border-line/50 bg-navy px-5 py-6" data-id="element-175" data-mp="1ablervz8pth8">
          <p className="font-semibold text-white" data-id="element-176" data-mp="15gpl6recuy20">Probalo. Si en {offerConfig.guaranteeDays} días no es lo que esperabas:</p>
          <p className="text-2xl font-black text-bright" data-id="element-177" data-mp="wdww8usnayfc">devolución del 100%</p>
          <p className="text-sm font-bold text-white/80" data-id="element-178" data-mp="wfzqjr0tzdpv">Según la política de devolución publicada.</p>
        </div>
      </div>
    </section>;
}